<template>
  <div class="about middle-main">
    <div class="about-con">
      <h1>感谢您关注《台商》月刊网站 <span>www.ts900.com</span></h1>
      <h3>您可以在我们的官方媒体平台了解我们
        <br> 以及最新的台商资讯
      </h3>
      <div class="flex-row icon-list">
        <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center">
          <svg-icon icon-class="facebook-active"></svg-icon>
        </a>
        <!-- <a href="http://weixin.qq.com/r/13WHn6XEG-hkreH89yDF" target="blank" class="items-center justify-center"> -->
        <div class="wx-icon" @click="wxMobile">
          <svg-icon icon-class="wx-active"></svg-icon>
        </div>
        <!-- </a> -->
        <a href="https://www.youtube.com/channel/UCHiVD1zjXzBs0XvhTu5b3pA" target="blank"
          class="items-center justify-center">
          <svg-icon icon-class="youtube-active"></svg-icon>
        </a>
        <a href="https://weibo.com/u/1890106622" target="blank" class="items-center justify-center"
          @mouseenter="hoverIcon('wb')" @mouseleave="hoverIcon('wb')">
          <svg-icon icon-class="wb-active"></svg-icon>
        </a>
        <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAA2nDgbCE4iGqok4SR_nWRK2d5Dro0O-ceo9w3DdnjSkE/"
          target="blank" class="items-center justify-center">
          <svg-icon icon-class="tt-active"></svg-icon>
        </a>
        <a href="https://www.douyin.com/user/MS4wLjABAAAAjOsLv8o28bYbKOPCcncREobBQ6wvEjANdOgNOeszQDA" target="blank"
          class="items-center justify-center">
          <img src="@/assets/images/dy.png" class="dy-icon">
        </a>
      </div>
      <span class="contact-email">联系邮箱: ts960@ts960.com</span>
      <img src="@/assets/images/about-bg.png" class="about-bg">
    </div>
    <!-- <div v-for="item in 100" :key="item">
            <div class="item">{{ item }}</div>
        </div> -->
    <div class="con" v-html="aboutCon"></div>
  </div>
</template>

<script>
import { getAboutInfo } from "@/assets/api/common.js";

export default {
  name: "about",
  components: {},
  data() {
    return {
      aboutCon: "",
    };
  },
  computed: {},
  created() {
    getAboutInfo("relatedByIntro").then((res) => {
      this.aboutCon = res.data.data.relatedContent;
    });
  },
  methods: {
    wxMobile() {
      this.$router.push('/wx-mobile');
    }
  },
};
</script>

<style lang="less" scoped>
.about-con {
  margin-top: 80px;
  padding: 60px 80px 47px 80px;
  background: linear-gradient(133deg, #212121 0%, #2E2E30 100%);
  border-radius: 24px;
  position: relative;
  font-size: 0;

  h1 {
    font-family: SourceHanSerifCN, SourceHanSerifCN;
    font-weight: 800;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 57px;
    text-align: left;
    font-style: normal;
    position: relative;
    width: fit-content;

    span {
      font-family: Arial, Arial;
      font-weight: normal;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 14px;
      text-align: center;
      font-style: italic;
      text-transform: uppercase;
      background: #E2291E;
      border-radius: 10px;
      padding: 3px 12px;
      position: absolute;
      right: -138px;
      top: 6px;
    }
  }

  h3 {
    font-family: SourceHanSerifCN, SourceHanSerifCN;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    margin-top: 8px;
    margin-bottom: 40px;
  }

  .icon-list {
    margin-bottom: 20px;

    .svg-icon {
      margin-right: 20px;
      width: 50px;
      height: 50px;
      background: #FFFFFF;
      padding: 9px;
      border-radius: 50px;
    }

    .dy-icon {
      background: #FFFFFF;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      padding: 10px;
    }
  }

  .contact-email {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
    line-height: 16px;
    letter-spacing: 1px;
    text-align: right;
    font-style: normal;
  }

  .about-bg {
    position: absolute;
    right: 0;
    bottom: 0;
    width: auto;
    height: 100%;
    object-fit: cover;
  }

  .con {
    font-family: NotoSansCJKTC;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: 1.4px;
    text-align: left;
    color: #333;
  }

  .sign {
    width: 233px;
    height: 116px;
    margin: 33px 0 47px 0;
  }
}

.svg-icon {
  width: 150px;
  height: 150px;
}

.con {
  // background: #F2F2F7;
  border-radius: 8px;
  // padding: 30px;
  margin-top: 80px;
  margin-bottom: 80px;
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #2C2C2E;
  line-height: 32px;
  text-align: justify;
  font-style: normal;
}

@media screen and (max-width: 768px) {
  .about-con {
    margin-top: 30px;

    h1 {
      font-size: 24px;
      line-height: 35px;

      span {
        position: static;
      }
    }

    h3 {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 20px;
    }

    .icon-list {
      .svg-icon {
        margin-right: 10px;
        width: 40px;
        height: 40px;
        padding: 6px;
      }

      .dy-icon {
        width: 40px;
        height: 40px;
        padding: 6px;
      }
    }
  }

  .con {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 24px;
    padding: 20px;
  }

  .about {
    padding: 0 20px;
  }

  .about-con {
    padding: 20px;
  }
}
</style>
<style>
.con img {
  margin: 10px auto;
  display: block;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue